module.exports = __webpack_public_path__ + "static/media/marvel.d77e20cc.jpg";